<div class="searchresult_scrn">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <a href="#" class="d-sm-inline-block create_quote">
            Create Quote
            <i class="fa fa-angle-right ml-2 btn_arrow"></i>
        </a>
    </div>



    <div class="row mb-4">
        <div class="col-lg-7 col-md-9 mb-2 form-inline">
            <label class="label_cls mr-2">Search Policies</label>
            <div class="input-group search_policies">
                <p-autoComplete [(ngModel)]="policyNumberModal"  placeholder="Policy number or named insured" [suggestions]="suggestpolicies" (completeMethod)="getPolicyBasedOnNumber($event)" (onSelect)="getPolicyBasedOnFilter()"></p-autoComplete>
                <span class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" (click)="searchPolicyDetails()">
                        <i class="fa fa-search"></i>
                    </button>
                </span>
            </div>
        </div>
        <div class="col-lg-5 col-md-9 mb-2 form-inline">
            <label class="label_cls mr-2">Policy Status</label>
            <p-dropdown [options]="statusDropdownList" [(ngModel)]="statusModal" optionLabel="name" (onChange)="getPolicyBasedOnFilter()"></p-dropdown>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <span class="heading_search_policies">
                Policies
            </span>
            <span class="float-right text-right">
                <span  class="search_policies_link mousePointer " (click)="exportExcel(policyGrid)">
                    <i class="fa fa-file-excel-o excel_icon_cls mr-1" style="font-size: 16px;"
                        aria-hidden="true"></i> 
                        Export </span>
            </span>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12 mt-0 mb-5 ">
            <p-table #policyGrid class="table client-table table-responsive" class="gen-paginator-override" [value]="policiesList"
                [rows]="10" [paginator]="true" pageLinks="8">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 13%;" pSortableColumn="policyNumber">Policy Number<p-sortIcon
                                field="policyNumber"></p-sortIcon>
                        </th>
                        <th style="width: 15%;" pSortableColumn="nameInsured">Name Insured<p-sortIcon
                                field="nameInsured"></p-sortIcon>
                        </th>
                        <th style="width: 12%;" pSortableColumn="effectiveDate">Effective Date<p-sortIcon
                                field="effectiveDate"></p-sortIcon>
                        </th>
                        <th style="width: 12%;" pSortableColumn="expireDate">Expire Date<p-sortIcon field="expireDate">
                            </p-sortIcon>
                        </th>
                        <th style="width: 15%;" pSortableColumn="lineOfBusinuss">Line of Business<p-sortIcon
                                field="lineOfBusinuss"></p-sortIcon>
                        </th>
                        <th style="width: 15%;" pSortableColumn="jobSiteAddress">Jobsite Address<p-sortIcon
                                field="jobSiteAddress"></p-sortIcon>
                        </th>
                        <th style="width: 10%;" pSortableColumn="status" class="text-center">Status<p-sortIcon
                                field="status"></p-sortIcon>
                        </th>
                        <th style="width: 8%;">&nbsp;</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-policies let-i="index">
                    <tr>
                        <td>{{policies?.policyNumber}}</td>
                        <td>{{policies?.nameInsured}}</td>
                        <td>{{policies?.effectiveDate | date:"MM/dd/yyyy"}}</td>
                        <td>{{policies?.expireDate | date:"MM/dd/yyyy"}}</td>
                        <td>{{policies?.lineOfBusinuss}}</td>
                        <td>{{policies?.jobSiteAddress}}</td>
                        <td class="text-center">
                            <span style="display: flex; justify-content: center;text-transform: uppercase;">
                            <span [ngClass]="getColorCode(policies?.status)" >{{policies?.status}}</span>
                        </span>
                        </td>
                        <td class="text-center"> <i class="fa fa-pencil-square-o icon_edit_clr" aria-hidden="true"></i>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>